var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse',{model:{value:(_vm.tabActive),callback:function ($$v) {_vm.tabActive=$$v},expression:"tabActive"}},_vm._l((_vm.data.tabList),function(item,index){return _c('el-collapse-item',{key:index,attrs:{"title":item.text,"name":index + ''}},[_c('l-form-wraper',{attrs:{"myComponents":item.children}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }